/**
 * Created by andrey on 19.08.2025
 */

const Map2dBorderSprite = cc.Sprite.extend({
    ctor: function (border) {
        this._super(border.res);

        ViewReader.setTopYAnchorElementData(this, border);
    },

    reuse: function (border) {
        this._super();

        this.setSpriteFrame(border.res);
        ViewReader.setTopYAnchorElementData(this, border);
    }
});

Map2dBorderSprite.PoolLimit = 200;

Map2dBorderSprite.GetFromPool = function (border) {
    return cleverapps.pool.getFromPool(Map2dBorderSprite, border) || new Map2dBorderSprite(border);
};